import React from 'react';

interface TableProps {
  children: React.ReactNode;
}

/**
 * The Table component is the parent component in which TableListItems will be placed.
 * TableListItems have to be wrapped inside the Table component so the dividers
 * between the different items will be present.
 *
 */

const Table = ({ children }: TableProps) => {
  return (
    <div
      tw="divide-y divide-silver-base pl-16 pr-16 bg-white"
      data-test-type="table-list"
    >
      {children}
    </div>
  );
};

export default Table;
